<template>
    <div class="order-list">
        <div class="order-header" @click="goStore(shopId)">
            <h2>{{shopName}} <i></i></h2>
            <span class="order-status" :class="{disable: status == 2}">{{status | getStatus}}</span>
        </div>
        <div class="list">
            <div class="product-img">
                <img :src="commonImg | urlProtocol" alt="">
            </div>
            <div class="product-info">
                <h3>{{commonName}}</h3>
                <div class="product-price">
                    <span>￥{{sellPrice}}</span>
                    <span>￥{{price}}</span>
                </div>
            </div>
        </div>
        <div class="order-total">
            <h2>共一件商品合计：<i>￥{{sellPrice}}</i></h2>
            <div class="show-qrcode">
                <span @click="showQrcode(status)" :class="{disable: status == 2}">展示二维码</span>
            </div>
        </div>
    </div>
</template>
<script>

    import conf from '@/app.conf.json';

    export default {
        name: 'Produce',
        props: [
            'shopName',
            'shopId',
            'status',
            'commonImg',
            'commonName',
            'sellPrice',
            'price',
            'qrCodeUrl',
            'shopLogo',
            'floorName',
            'startTime',
            'endTime',
            'shopBunk',
            'commonNo'
        ],
        methods: {
            showQrcode(status) {

                if (status == 2) {
                    return;
                }

                let data = {
                    qrCodeUrl: this.qrCodeUrl,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    shopLogo: this.shopLogo,
                    shopName: this.shopName,
                    floorName: this.floorName,
                    shopBunk: this.shopBunk
                };

                window.localStorage.setItem('qrdata', JSON.stringify(data));
                this.$router.push({
                    name: 'Qrcode',
                });
            },
            goStore(shopId) {

                window.location.href = conf.otherPage.storePage + shopId;
            }
            /*goProduct(id, no) {

                let urlParams = this.$route.params;

                this.$router.push({
                    name: 'Product',
                    params: {
                        commonId: '36',
                        commonNo: no
                    }
                });
            }*/
        }
    }
</script>
<style scoped>
    .disable {
        color: #a9a9a9;
    }
    .order-list {
        background: #fff;
        font-family: "PingFangSC-Regular";

        .list {
            border-bottom: 1px solid #f2f2f2;
            height: auto;
            overflow: hidden;
            padding: 10px 17px;

            .product-img {
                margin-right: 41px;
                float: left;
                display: block;
                width: 160px;
                height: 160px;

                img {
                    display: block;
                    overflow: hidden;
                    width: 100%;
                    height: 100%;
                }
            }

            h3 {
                font-size: 32px;
                color: #222222;
            }

            .product-price {
                margin-top: 17px;
                display: block;

                span:nth-of-type(1) {
                    font-size:30px;
                    color:#ff6600;
                    font-weight: bold;
                }

                span:nth-of-type(2) {
                    font-size:22px;
                    color:#b4b4b4;
                    margin-left: 11px;
                    text-decoration: line-through;
                }
            }
        }
    }

    .order-header {
        position: relative;
        height: 82px;
        line-height: 82px;
        font-size:30px;
        color:#222222;

        h2 {
            height: 82px;
            line-height: 82px;
            vertical-align: middle;
            border-bottom: 1px solid #f2f2f2;
            position: relative;
            text-indent: 80px;

            &:before {
                display: block;
                width: 34px;
                height: 36px;
                content: '';
                position: absolute;
                top: 50%;
                background: url("../../assets/store-icon.png") 0 0 no-repeat;
                background-size: 34px 36px;
                margin-top: -17px;
                left: 20px;

            }

             i {
                 margin-left: 22px;
                 vertical-align: middle;
                 display: inline-block;
                 width: 15px;
                 height: 82px;
                 content: '';
                 background: url("../../assets/arrow-icon.png") 0 40% no-repeat;
                 background-size: 15px 28px;
             }
        }
        .order-status {
            height: 100%;
            font-size: 24px;
            position: absolute;
            top: 0;
            right: 20px;
        }
    }

    .order-total {
        margin-top: 12px;
        height: 125px;
        font-size:26px;
        color:#222222;

        h2 {
            padding: 0 20px;
            text-align: right;

            i {
                font-size:30px;
                color:#ff6600;
            }
        }

        .show-qrcode {
            height: 46px;
            position: relative;
            margin-top: 11px;

            .time-out {
                color: #a9a9a9;

                span {
                    border: 1px solid #a9a9a9;
                }
            }
        }
        .show-qrcode span {
            position: absolute;
            right: 20px;
            top: 0;
            display: block;
            width: 189px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            border: 1px solid #ffaa00;
            font-size:26px;
            color:#ffaa00;

            &.disable {
                color: #a9a9a9;
                 border: 1px solid #a9a9a9;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/commons/Product.vue